import { action } from 'typesafe-actions'
import { MerchantsChannelsTypes } from './types'
import { MerchantChannelReport, DataStream } from '../../interfaces'

export const viewMerchantChannelPaymentsRequest = (payload: any) =>
  action(MerchantsChannelsTypes.VIEW_MERCHANT_CHANNEL_PAYMENTS_REQUEST, payload)

export const viewMerchantChannelPaymentsSuccess = (
  data: MerchantChannelReport
) => action(MerchantsChannelsTypes.VIEW_MERCHANT_CHANNEL_PAYMENTS_SUCCESS, data)

export const viewMerchantChannelPaymentsFailure = (error: any) =>
  action(MerchantsChannelsTypes.VIEW_MERCHANT_CHANNEL_PAYMENTS_FAILURE, error)

export const exportMerchantChannelPaymentsRequest = (payload: any) =>
  action(
    MerchantsChannelsTypes.EXPORT_MERCHANT_CHANNEL_PAYMENTS_REQUEST,
    payload
  )

export const exportMerchantChannelPaymentsSuccess = (data: DataStream) =>
  action(MerchantsChannelsTypes.EXPORT_MERCHANT_CHANNEL_PAYMENTS_SUCCESS, data)

export const exportMerchantChannelPaymentsFailure = (error: any) =>
  action(MerchantsChannelsTypes.EXPORT_MERCHANT_CHANNEL_PAYMENTS_FAILURE, error)

export const clearChannels = () => action(MerchantsChannelsTypes.CLEAR_CHANNELS)
